document.addEventListener("DOMContentLoaded", function () {
  const menuBtn = document.querySelector('.header__menu-btn');
  const mobileMenu = document.querySelector('.header__mobile-menu');
  const closeBtn = document.querySelector('.header__mobile-menu-close');
  const mobileNavLinks = document.querySelectorAll('.header__mobile-menu-list a[href^="#"]');

  // Mobile menu
  menuBtn.addEventListener('click', () => {
    mobileMenu.classList.add('is-open');
    menuBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = "hidden"; // Prevent scrolling when menu is open
  });
  
  closeBtn.addEventListener('click', () => {
    mobileMenu.classList.remove('is-open');
    menuBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = ""; // Re-enable scrolling
  });

  // Close mobile menu when clicking on a link
  mobileNavLinks.forEach((link) => {
    link.addEventListener("click", () => {
      mobileMenu.classList.remove("is-open");
      document.body.style.overflow = ""; // Re-enable scrolling
    });
  });

  // Logo click scrolls to top
  document.querySelector('.header__logo').addEventListener('click', (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });

  // Smooth scrolling for navigation links
  const navLinks = document.querySelectorAll(
    '.header__nav-list a[href^="#"], .header__mobile-menu-list a[href^="#"]',
  );

  navLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();

      const targetId = this.getAttribute("href").substring(1);
      const targetSection = document.getElementById(targetId);

      if (targetSection) {
        const headerHeight = document.querySelector("header").offsetHeight;
        const targetPosition = targetSection.offsetTop - headerHeight;

        window.scrollTo({
          top: targetPosition,
          behavior: "smooth",
        });
      }
    });
  });
  
  // Treinamento tabs
  const tabButtons = document.querySelectorAll('.treinamento__nav-link');
  const tabPanels = document.querySelectorAll('.treinamento__panel');

  tabButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.tab;
      tabButtons.forEach((b) => b.classList.remove('is-active'));
      tabPanels.forEach((p) => p.classList.remove('is-active'));
      btn.classList.add('is-active');
      const panel = document.querySelector(`.treinamento__panel[data-panel="${target}"]`);
      if (panel) panel.classList.add('is-active');
    });
  });

  // Hero slider
  const slides = document.querySelectorAll('.hero__slide');
  let current = 0;
  
  setInterval(() => {
    slides[current].classList.remove('is-active');
    current = (current + 1) % slides.length;
    slides[current].classList.add('is-active');
  }, 5000);
  
});